import { Skeleton } from '@crehana/compass.ui';

export const TrackingCardSkeleton = () => {
  return (
    <div className=" tw-inline-block tw-border tw-border-solid tw-border-neutral-light-400  tw-rounded-[10px] tw-pt-1.6 tw-pl-1.6 tw-pb-3.6 tw-w-full">
      <div className="tw-w-full tw-flex tw-justify-center tw-pb-1.6">
        <Skeleton
          animated
          className="tw-h-1.6 tw-w-1/2 tw-rounded-full tw-mb-0.8"
        />
      </div>
      <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-pr-[2.9rem]">
        <div className="tw-w-full ">
          <Skeleton
            animated
            className="tw-h-1 tw-w-full tw-rounded-full tw-mb-0.8"
          />
          <Skeleton
            animated
            className="tw-h-1 tw-w-full tw-rounded-full tw-mb-0.8"
          />
          <Skeleton
            animated
            className="tw-h-1 tw-w-1/2 tw-rounded-full tw-mb-0.8"
          />
        </div>
        <div className="tw-relative tw-pl-2">
          <Skeleton
            animated
            className="tw-w-[7.6rem] tw-h-[7.6rem] tw-rounded-full tw-mb-0.8"
          />
          <div className="tw-absolute tw-top-[1.6rem] tw-right-[1.6rem] tw-h-4.4 tw-w-4.4 tw-rounded-full tw-bg-neutral-light-100"></div>
        </div>
      </div>
    </div>
  );
};
